import React, { Component } from 'react';
import SortableTree, { addNodeUnderParent, removeNodeAtPath, changeNodeAtPath } from '@nosferatu500/react-sortable-tree';
import { Switch, Row, Col, Button, Space, Spin, Alert, DatePicker, Popover, message, Input } from 'antd';
import { AppstoreAddOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons';
import moment from 'moment';
import t from '../i18n';

import _ from 'lodash';

const getNodeKey = ({ treeIndex }) => treeIndex;


class ChartOfAccounts extends Component {

  constructor(props) {

    super(props);

    const tree = this.createDataTree(props.chartOfAccounts);

    this.state = {
      date: moment(),
      loadings: [],
      treeData: tree,
      // treeData: [
      //   // { id:1, display_name: 'Chicken', children: [{ display_name: 'Egg', id: 3 }] },
      //   { id: 2, display_name: 'Loading...', children: [{ display_name: 'Unload', id: 4 }] },
      // ],
    };
  }

  createDataTree(dataset) {
    let hashTable = Object.create(null);
    dataset.forEach(aData => hashTable[aData.id] = { ...aData, children: [] });
    let dataTree = [];
    dataset.forEach(aData => {
      if (aData?.parent_id) hashTable[aData.parent_id].children.push(hashTable[aData.id]);
      else dataTree.push(hashTable[aData.id]);
    });
    return dataTree;
  }

  componentDidMount() {
    // this.loadData();

  }


  // loadData = () => {


  //   this.setState({ loading: true });
  //   var $this = this;

  //   $.ajax({
  //     type: "get",
  //     dataType: 'json',
  //     // url: '/api/v1/chart_of_accounts',
  //     url: '/accounting/chart_of_accounts/',
  //     data: {
  //       token: Spree.api_key,
  //     },
  //     success: function (response) {
  //       const tree = $this.createDataTree(response);

  //       $this.setState({ treeData: tree, excelData: response, loading: false });

  //       $this.setState({
  //         loading: false,
  //       });

  //       return true;

  //     },
  //     error: function (response, textStatus, errorThrown) {
  //       console.log('delete error', response.responseText);
  //       message.error(response.responseText);

  //       return false;
  //     },

  //     // complete: function(response, textStatus, errorThrown) {
  //     //   debugger
  //     //   show_flash('error', response.responseText);
  //     // },
  //   });

  // };



  downloadExcel = () => {

    const { excelData } = this.state;
    const data = excelData.map(d => [" ".repeat(d.depth * 2) + d.display_name, d.type, nonZeroAmount(d.debit_balance), nonZeroAmount(d.credit_balance)]);

    // const data = this.state.excelData;


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Trial Balance',
      {
        views: [{ showGridLines: false }],
        headerFooter: { firstHeader: "Trial Balance", firstFooter: "Biscraft Powered" },
        style: {
          font: {
            name: 'Calibri',
            family: 4,
            size: 16,
          }
        },
      }
    );
    // worksheet.properties.defaultRowHeight = 15;
    // worksheet.getCell('A1').note = 'Hello, ExcelJS!';
    const table = worksheet.addTable({
      name: 'TrialBalance',
      displayName: 'Trial Balance As On ' + moment(this.state.date).format('lll'),
      ref: 'A1',
      headerRow: true,
      totalsRow: true,

      style: {
        // theme: 'TableStyleDark3',
        showRowStripes: true,
        font: {
          name: 'Calibri',
          family: 4,
          size: 30,
          underline: true,
          bold: true
        }
      },
      columns: [
        { name: 'Account Name', totalsRowLabel: 'Totals:', filterButton: true },
        { name: 'Account Type', totalsRowLabel: '', filterButton: true },
        { name: 'Debit Balance', totalsRowFunction: 'sum', filterButton: false },
        { name: 'Credit Balance', totalsRowFunction: 'sum', filterButton: false },
      ],
      rows: data,
    });

    const font = { name: 'Calibri', size: 12 };

    var nameCol = worksheet.getColumn(1);
    var typeCol = worksheet.getColumn(2);
    var debitCol = worksheet.getColumn(3);
    var creditCol = worksheet.getColumn(4);

    [nameCol, typeCol, debitCol, creditCol].forEach(col => {
      col.width = 25;
      col.font = font;
    });
    nameCol.width = 40;
    nameCol.alignment = { wrapText: true };

    // debitCol.eachCell(function (cell, rowNumber) {
    //   // ...
    // });
    debitCol.numFmt = '""#,##0.00;[Red]\-""#,##0.00';
    creditCol.numFmt = '""#,##0.00;[Red]\-""#,##0.00';
    table.commit();


    const filename = 'trial_balance_';
    return workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], {
        type: "application/octet-stream"
      }), `${filename}-${moment().format('YYYY-MM-DD__HH:mm:ss')}.xlsx`);
    });
  };

  saveChanges = (node, path, event) => {
    const changed = node.display_nameChanged ?? node.codeChanged
    if (!changed || !node.display_name) return;
    const $this = this;
    $.ajax({
      type: node.id ? "PUT" : "POST",
      dataType: 'json',
      url: '/accounting/chart_of_accounts/' + ifHasValue(node.id),
      data: {
        ...node, token: Spree.api_key,
      },
      success: function (response) {

        $this.setState(state => ({
          treeData: changeNodeAtPath({
            treeData: state.treeData,
            path,
            getNodeKey,
            newNode: { ...node, ...response },
          }),
        }));

        $this.setState({
          loading: false,
        });
        return true;

      },
      error: function (response, textStatus, errorThrown) {
        console.log('delete error', response.responseText);
        message.error(response.responseText);

        return false;
      },

      // complete: function(response, textStatus, errorThrown) {
      //   debugger
      //   show_flash('error', response.responseText);
      // },
    });

  }




  removeAccount = async (node, path) => {

    if (!node.id){ //newly added not persisted yet
      this.setState(state => ({
        treeData: removeNodeAtPath({
          treeData: state.treeData,
          path,
          getNodeKey,
        }),
      }));
      return;
    }

    const { loadings } = this.state;
    loadings[node.id] = true;
    this.setState({ loadings })
    const $this = this;
    $.ajax({
      type: "DELETE",
      dataType: 'json',
      url: '/accounting/chart_of_accounts/' + node.id,
      data: {
        token: Spree.api_key,
      },
      success: function (response) {
        $this.setState(state => ({
          treeData: removeNodeAtPath({
            treeData: state.treeData,
            path,
            getNodeKey,
          }),
        }));
        message.info(t('account_removed'))
        return true;

      },
      error: function (response, textStatus, errorThrown) {
        message.error(response.responseText);
        return false;
      },
      complete: function(response, textStatus, errorThrown) {
        loadings[node.id] = false;
        $this.setState({ loadings })
      },
    });

  };



  render() {
    if (!this.state.treeData) return <div />;
    const { searchString, searchFocusIndex, searchFoundCount } = this.state;

    // Case insensitive search of `node.title`
    const customSearchMethod = ({ node, searchQuery }) =>
      searchQuery &&
      (
        node.display_name.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1
                      ||
        ifHasValue(node.code).toString().indexOf(searchQuery) > -1
      );

    const selectPrevMatch = () =>
      this.setState({
        searchFocusIndex:
          searchFocusIndex !== null
            ? (searchFoundCount + searchFocusIndex - 1) % searchFoundCount
            : searchFoundCount - 1,
      });

    const selectNextMatch = () =>
      this.setState({
        searchFocusIndex:
          searchFocusIndex !== null
            ? (searchFocusIndex + 1) % searchFoundCount
            : 0,
      });
    // const { treeData, date, loading, rowSelection, checkStrictly, excelData } = this.state;
    const { loadings } = this.state
    return (
      <div>
        <Space>
          <Alert message={`Chart Of Account`} type="info" showIcon >
          </Alert>

          <Switch checkedChildren={<div><span>{t('editing')}</span> </div>}
            unCheckedChildren={<span>{t('edit')}</span>}
            onChange={(checked) => { this.setState({ editing: checked }); }}

          />
          {/* <form
            style={{ display: 'inline-block' }}
            onSubmit={event => {
              event.preventDefault();
            }}
          > */}
            <Input
              id="find-box"
              type="text"
              placeholder="Search..."
              style={{ fontSize: '1rem' }}
              value={searchString}
              onChange={event =>
                this.setState({ searchString: event.target.value })
              }
            />

            <button
              type="button"
              disabled={!searchFoundCount}
              onClick={selectPrevMatch}
            >
              &lt;
          </button>

            <button
              type="submit"
              disabled={!searchFoundCount}
              onClick={selectNextMatch}
            >
              &gt;
          </button>

            <span>
              &nbsp;
            {searchFoundCount > 0 ? searchFocusIndex + 1 : 0}
            &nbsp;/&nbsp;
            {searchFoundCount || 0}
            </span>
          {/* </form> */}
        </Space>

        <div style={{ height: 500, width: 1000 }}>
          <SortableTree
            treeData={this.state.treeData}
            onChange={treeData => this.setState({ treeData })}
            searchMethod={customSearchMethod}
            //
            // The query string used in the search. This is required for searching.
            searchQuery={searchString}
            searchFocusOffset={searchFocusIndex}
            searchFinishCallback={matches =>
              this.setState({
                searchFoundCount: matches.length,
                searchFocusIndex:
                  matches.length > 0 ? searchFocusIndex % matches.length : 0,
              })
            }
            generateNodeProps={({ node, path }) => ({
              buttons: [
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  hidden={node.id}
                  size="small"
                  style={{ margin: '5px' }}
                >Save</Button>,
                <Button
                  icon={<AppstoreAddOutlined />}
                  style={{ margin: '5px' }}
                  size="small"
                  hidden={!this.state.editing || !node.id}
                  onClick={() => {
                    // console.log("node", node);

                    this.setState(state => ({
                      treeData: addNodeUnderParent({
                        treeData: state.treeData,
                        parentKey: path[path.length - 1],
                        expandParent: true,
                        getNodeKey,
                        newNode: {
                          display_name: '',
                          code: '',
                          display_name_place_holder: `New Sub Account`,
                          code_place_holder: `Account Code`,
                          parent_id: node.id
                        },
                        addAsFirstChild: true,
                      }).treeData,
                    }));
                  }
                  }
                >
                  Add Child
                </Button>,
                <Button
                  loading={loadings[node.id]}
                  icon={<DeleteOutlined />}
                  style={{ margin: '5px' }}
                  size="small"
                  danger
                  type="dashed"
                  hidden={!this.state.editing}
                  onClick={async () => {
                    this.removeAccount(node, path)
                  }}

                >
                  Remove
                </Button>,
              ],
              subtitle: (
                this.state.editing ?
                  <div />
                  :
                  node.code
              ),

              title: (
                this.state.editing ?
                  <Space>
                    <input
                      value={node.code}
                      placeholder={node.code_place_holder || node.code}
                      onChange={event => {
                        const code = event.target.value;
                        // node.code = code
                        node.codeChanged = true
                        this.setState(state => ({
                          treeData: changeNodeAtPath({
                            treeData: state.treeData,
                            path,
                            getNodeKey,
                            newNode: { ...node, code },
                          }),
                        }));
                      }}
                    onBlur={event => {
                      // const name = event.target.value;
                      // node.codeChanged
                      // console.log('node.codeChanged', node)
                      this.saveChanges(node, path, event)

                      // debugger;

                    }}
                    />
                    <input
                      value={node.display_name}
                      placeholder={node.display_name_place_holder || node.display_name}
                      onChange={event => {
                        const display_name = event.target.value;
                        // node.display_name = display_name
                        node.display_nameChanged = true
                        // debugger;
                        this.setState(state => ({
                          treeData: changeNodeAtPath({
                            treeData: state.treeData,
                            path,
                            getNodeKey,
                            newNode: { ...node, display_name },
                          }),
                        }));
                      }}
                      onBlur={event => {
                        // console.log('node name changed', node)
                        this.saveChanges(node, path, event)
                      }}

                    />
                  </Space>
                  :
                  node.display_name
              ),
            })}
          />
        </div>


      </div>
    );
  }
}

export default ChartOfAccounts;
